import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { IconButton, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";

import { ActionButton } from "../../../../components";

EditarAtividadeButton.propTypes = {
  styleIcon: PropTypes.object,
  useIconWithLabel: PropTypes.bool,
  onClick: PropTypes.func,
  useJustLabel: PropTypes.bool,
  somenteConcluidas: PropTypes.bool,
  atividadeId: PropTypes.number,
};

function EditarAtividadeButton({
  styleIcon,
  useIconWithLabel = false,
  useJustLabel,
  somenteConcluidas,
  atividadeId,
  ...props
}) {
  const intl = useIntl();

  const renderActionButton = () => (
    <ActionButton
      id={atividadeId ? `btn-editar-atividade-${atividadeId}` : "btn-editar-atividade"}
      type={useJustLabel ? "text" : "menu"}
      onClick={() => props.onClick()}
      icon={!useJustLabel && <EditIcon />}
      label={intl.formatMessage({ defaultMessage: "Editar" })}
      disabled={somenteConcluidas}
      style={{ color: somenteConcluidas ? "rgba(0, 0, 0, 0.26)" : useJustLabel && "#fff" }}
    />
  );

  if (useIconWithLabel || useJustLabel) {
    if (somenteConcluidas)
      return (
        <Tooltip
          title={intl.formatMessage({
            defaultMessage: "Atividades concluídas não podem ser editadas",
          })}
        >
          <span>{renderActionButton()}</span>
        </Tooltip>
      );
    return renderActionButton();
  }
  return (
    <IconButton {...props}>
      <EditIcon style={styleIcon} />
    </IconButton>
  );
}
export default EditarAtividadeButton;
